export default __webpack_public_path__ + "55364f0db4189d3d893d144e5f9a2b12.png";